export const cypher = {
  'Em análise': {
    tag: 'is-info',
  },
  Aprovada: {
    tag: 'is-info',
    translation: 'Aguardando formalização',
  },
  Recusada: {
    tag: 'is-danger',
  },
  Cancelada: {
    tag: 'is-danger',
  },
  Pendência: {
    tag: 'is-warning',
  },
  Finalizada: {
    tag: 'is-info',
    translation: 'Conferindo proposta',
  },
  Conferida: {
    tag: 'is-info',
    translation: 'Conferindo proposta',
  },
  Liberada: {
    tag: 'is-info',
    translation: 'Aguardando pagamento',
  },
  Paga: {
    tag: 'is-success',
  },
};
